"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var theme = {
  x0: 0,
  x025: 1,
  x05: 2,
  x1: 4,
  x2: 8,
  x3: 12,
  x4: 16,
  x5: 20,
  x6: 24,
  x8: 32,
  x10: 40,
  x12: 48,
  x15: 60,
  x20: 80,
  sizeBase: 4,
  sizeGrid: 20,
  fontSize1: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize2: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize3: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize4: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize5: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize6: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize7: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontSize8: {
    fontSize: 44,
    lineHeight: "52px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  toneValueX1: 0.04,
  toneValueX2: 0.08,
  toneValueX3: 0.12,
  toneValueX4: 0.16,
  toneValueX6: 0.24,
  toneValueX8: 0.32,
  toneValueX12: 0.48,
  toneValueX18: 0.72,
  toneValueOverlay: 0.72,
  toneValueBase: 0.48,
  toneValueViewer: 0.88,
  toneValueToolbar: 0.24,
  toneValueHover: 0.08,
  toneValueActive: 0.12,
  toneValueFocus: 0.48,
  depth0: "none",
  depth1: "0 2px 0 0 rgba(0, 0, 0, 0.04)",
  depth2: "0 4px 48px 0 rgba(0, 0, 0, 0.72)",
  depth3: "0 4px 32px 0 rgba(0, 0, 0, 0.48)",
  depthInset: "inset 0 2px 0 0 rgba(0, 0, 0, 0.04)",
  colorBorder: {
    normal: "rgba(255, 255, 255, 0.2)",
    hover: "rgba(255, 255, 255, 0.32)",
    active: "rgba(255, 255, 255, 0.48)",
    focus: "rgba(255, 255, 255, 0.48)"
  },
  colorDivider: {
    normal: "rgba(0, 0, 0, 0.4)"
  },
  typeBorderButton: "solid",
  typeBorderPosition: "inset",
  colorBgToolbar: {
    normal: "#000000",
    hover: "#1F1F1F",
    active: "#3D3D3D"
  },
  colorBgSidebar: {
    normal: "transparent",
    hover: "rgba(255, 255, 255, 0.12)",
    active: "rgba(255, 255, 255, 0.24)"
  },
  depthSidebar: "none",
  colorBgTint: "transparent",
  colorBgGradientTint: "transparent",
  animationDurationL: "0.4s",
  animationDurationM: "0.2s",
  animationDurationS: "0.1s",
  transitionEasingDefault: "cubic-bezier(0.3, 0.3, 0.5, 1)",
  paddingBase: 20,
  paddingPopupBase: 32,
  paddingPopupHeader: 24,
  layoutWidthDesktopS: 768,
  colorPrimary: {
    normal: "#0C7CFF",
    hover: "#1F86FF",
    active: "#298CFF"
  },
  colorSecondary: {
    normal: "#ff9e00",
    hover: "#FFA614",
    active: "#FFAA1F"
  },
  sizeBorderWidth: 1,
  sizeBorderWidthTab: 2,
  sizeBorderWidthBar: 4,
  sizeBorderWidthAccent: 8,
  sizeBorderWidthAccentSecondary: 4,
  sizeBorderRadius: 4,
  sizeBorderRadiusPaper: 12,
  fontWeight: 400,
  fontWeightBold: 700,
  fontFamily: "MailSans, Helvetica, Arial, sans-serif",
  fontSize: 15,
  lineHeight: 20,
  fontH0: {
    fontSize: 32,
    lineHeight: "40px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH1: {
    fontSize: 24,
    lineHeight: "32px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH2: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH3: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH4: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH5: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontH6: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 500,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontBody: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontParagraph: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontList: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontListItem: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontFootnote: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontLead: {
    fontSize: 20,
    lineHeight: "28px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontQuote: {
    fontSize: 17,
    lineHeight: "24px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontTableHeader: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontControl: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontControlLabel: {
    fontSize: 13,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontTab: {
    fontSize: 15,
    lineHeight: "20px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontBadge: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  fontDisclaimer: {
    fontSize: 11,
    lineHeight: "12px",
    fontWeight: 400,
    fontFamily: "MailSans, Helvetica, Arial, sans-serif"
  },
  sizeControlHeight: 40,
  sizeControlButtonWidthMin: 104,
  sizeControlButtonLargeHeight: 48,
  sizeControlButtonLargeWidth: 48,
  sizeControlButtonSmallHeight: 32,
  sizeControlButtonSmallWidth: 104,
  sizeControlButtonIconWidth: 40,
  sizeControlButtonSliderHeight: 24,
  sizeControlButtonSliderWidth: 12,
  sizeControlButtonSliderWidthPointer: 16,
  sizeControlFieldWidthMin: 380,
  sizeControlLabelWidth: 184,
  sizeControlCheckHeight: 16,
  sizeControlCheckWidth: 16,
  sizeProgress: 4,
  sizeProgressScroll: 12,
  sizeDotBullet: 4,
  sizeDotIndicate: 8,
  sizeDotClickable: 12,
  sizeArrowHeight: 8,
  sizeArrowWidth: 12,
  sizePopupSmall: 420,
  sizePopupMedium: 680,
  sizePopupLarge: 880,
  paddingControlHorizontal: 12,
  paddingControlVertical: 0,
  paddingControlMore: 8,
  paddingControlMoreIcon: 8,
  paddingControlButton: 16,
  paddingControlButtonIcon: 20,
  paddingControlDiv: 4,
  paddingMenu: 8,
  paddingTag: 8,
  paddingTab: 16,
  paddingArrow: 12,
  paddingTableHorizontal: 16,
  paddingTableVertical: 16,
  paddingSliceTop: 40,
  paddingSliceBottom: 60,
  marginControl: 12,
  marginFormLabelHorizontal: 16,
  marginFormLabelVertical: 4,
  marginFormTip: 4,
  marginFormFieldHorizontal: 20,
  marginFormFieldVertical: 24,
  marginFormFieldSet: 32,
  marginIcon: 8,
  marginChoice: 8,
  marginMenu: 2,
  marginTooltip: 8,
  marginTag: 8,
  marginTab: 8,
  marginBullet: 12,
  marginAttribute: 4,
  marginPopup: 24,
  sizeIconUI: 18,
  sizeIconHeader: 20,
  sizeIconWysiwyg: 14,
  sizeIllustrationS: 48,
  sizeIllustrationXM: 72,
  sizeIllustrationM: 96,
  sizeIllustrationL: 144,
  sizeIllustrationXXL: 228,
  sizeAvatarXS: 24,
  sizeAvatarS: 32,
  sizeAvatarM: 48,
  sizeAvatarL: 96,
  sizeAvatarXL: 128,
  widthTouch: "(width < 768px)",
  widthDesktopS: "(width >= 768px)",
  widthFromDesktopS: "(width >= 768px)",
  widthToTouch: "(width < 768px)",
  colorStateHover: {
    normal: "rgba(255, 255, 255, 0.08)"
  },
  colorStateActive: {
    normal: "rgba(255, 255, 255, 0.12)"
  },
  colorOverlay: {
    normal: "rgba(0, 0, 0, 0.72)"
  },
  colorText: {
    normal: "#ffffff"
  },
  colorTextSecondary: {
    normal: "#7B7B7B"
  },
  colorTextContrast: {
    normal: "#ffffff"
  },
  colorIcon: {
    normal: "#D7D7D7"
  },
  colorIconContrast: {
    normal: "#ffffff"
  },
  colorLink: {
    normal: "#589BFF"
  },
  colorLinkVisited: {
    normal: "#6492DA"
  },
  colorLinkContrast: {
    normal: "#ffffff"
  },
  colorTrueBlack: {
    normal: "#000000"
  },
  colorTrueWhite: {
    normal: "#ffffff"
  },
  colorState: {
    normal: "#FFFFFF"
  },
  colorAlert: {
    normal: "#c1341b"
  },
  colorBgHighlight: {
    normal: "#6C4E00"
  },
  colorIconSecondary: {
    normal: "#707070",
    hover: "#7B7B7B",
    active: "#818181"
  },
  colorBg: {
    normal: "#1F1F1F",
    hover: "#313131",
    active: "#3A3A3A"
  },
  colorBgPopup: {
    normal: "#313131",
    hover: "#414141",
    active: "#4A4A4A"
  },
  colorBgSecondary: {
    normal: "rgba(255, 255, 255, 0.08)",
    hover: "rgba(255, 255, 255, 0.16)",
    active: "rgba(255, 255, 255, 0.2)"
  },
  colorBgContrast: {
    normal: "#333333",
    hover: "#434343",
    active: "#4B4B4B"
  },
  colorBgThumbnail: {
    normal: "#1F1F1F",
    hover: "#313131",
    active: "#3A3A3A"
  },
  colorSuccess: {
    normal: "#0DC268",
    hover: "#20C774",
    active: "#2AC97A"
  },
  colorError: {
    normal: "#ED0A34",
    hover: "#EE1E44",
    active: "#EF274C"
  },
  colorWarning: {
    normal: "#fffce0",
    hover: "#FFFCE2",
    active: "#FFFCE4"
  },
  colorBgWarning: {
    normal: "#fffce0",
    hover: "#FFFCE2",
    active: "#FFFCE4"
  },
  colorRating: {
    normal: "#ffd400",
    hover: "#FFD714",
    active: "#FFD91F"
  },
  colorNotify: {
    normal: "#ff9e00",
    hover: "#FFA614",
    active: "#FFAA1F"
  },
  colorSocialVk: {
    normal: "#4680C2",
    hover: "#558AC7",
    active: "#5C8FC9"
  },
  colorSocialOk: {
    normal: "#ee8208",
    hover: "#EF8C1C",
    active: "#F09126"
  },
  colorSocialMir: {
    normal: "#117eda",
    hover: "#2488DD",
    active: "#2E8DDE"
  },
  colorSocialFb: {
    normal: "#0561af",
    hover: "#196EB5",
    active: "#2374B9"
  },
  colorSocialTwitter: {
    normal: "#00bff3",
    hover: "#14C4F4",
    active: "#1FC7F4"
  },
  colorSocialDribbble: {
    normal: "#ea4c89",
    hover: "#EC5A92",
    active: "#ED6197"
  },
  colorSocialBehance: {
    normal: "#0057ff",
    hover: "#1464FF",
    active: "#1F6BFF"
  },
  colorPaletteRed1: {
    normal: "#fc2c38",
    hover: "#FC3D48",
    active: "#FC4550"
  },
  colorPaletteRed2: {
    normal: "#eb1981",
    hover: "#ED2B8B",
    active: "#ED3590"
  },
  colorPaletteRed3: {
    normal: "#ff71bb",
    hover: "#FF7CC0",
    active: "#FF82C3"
  },
  colorPaletteOrange1: {
    normal: "#ff8b2e",
    hover: "#FF943F",
    active: "#FF9947"
  },
  colorPaletteOrange2: {
    normal: "rgba(255, 158, 0, 0.12)",
    hover: "rgba(255, 158, 0, 0.2)",
    active: "rgba(255, 158, 0, 0.24)"
  },
  colorPaletteYellow1: {
    normal: "#ffc311",
    hover: "#FFC824",
    active: "#FFCA2E"
  },
  colorPaletteGreen1: {
    normal: "#aee113",
    hover: "#B4E326",
    active: "#B8E52F"
  },
  colorPaletteGreen2: {
    normal: "#59c354",
    hover: "#66C862",
    active: "#6DCA69"
  },
  colorPaletteGreen3: {
    normal: "#37eb94",
    hover: "#47ED9D",
    active: "#4FEDA1"
  },
  colorPaletteGreen4: {
    normal: "#00b1b3",
    hover: "#14B7B9",
    active: "#1FBABC"
  },
  colorPaletteGreen5: {
    normal: "rgba(92, 186, 56, 0.12)",
    hover: "rgba(92, 186, 56, 0.2)",
    active: "rgba(92, 186, 56, 0.24)"
  },
  colorPaletteGreen6: {
    normal: "rgba(0, 230, 180, 0.08)",
    hover: "rgba(0, 230, 180, 0.16)",
    active: "rgba(0, 230, 180, 0.2)"
  },
  colorPaletteBlue1: {
    normal: "#2951ff",
    hover: "#3A5FFF",
    active: "#4366FF"
  },
  colorPaletteBlue2: {
    normal: "#00abf2",
    hover: "#14B2F3",
    active: "#1FB5F4"
  },
  colorPaletteBlue3: {
    normal: "#26dfdf",
    hover: "#37E2E2",
    active: "#40E3E3"
  },
  colorPaletteBlue4: {
    normal: "rgba(0, 95, 249, 0.12)",
    hover: "rgba(0, 95, 249, 0.2)",
    active: "rgba(0, 95, 249, 0.24)"
  },
  colorPaletteViolet1: {
    normal: "#6c00ff",
    hover: "#7814FF",
    active: "#7E1FFF"
  },
  colorPaletteViolet2: {
    normal: "#ae73ff",
    hover: "#B47EFF",
    active: "#B884FF"
  },
  colorIconFavorite: {
    normal: "#FC2C38",
    hover: "#FC3D48",
    active: "#FC4550"
  },
  colorIconUnread: {
    normal: "#0C7CFF",
    hover: "#1F86FF",
    active: "#298CFF"
  },
  colorBgPlaceholder: {
    normal: "#000000"
  },
  colorTextSidebar: {
    normal: "#FFFFFF"
  },
  colorIconSidebar: {
    normal: "#FFFFFF"
  },
  colorBorderSidebar: {
    normal: "rgba(255, 255, 255, 0.12)"
  },
  colorScrollbar: {
    normal: "#707070"
  },
  colorBgSecondaryFlat: {
    normal: "#313131",
    hover: "#414141",
    active: "#4A4A4A"
  },
  colorCategoryMailings: {
    normal: "#FF9C37",
    hover: "#FFA447",
    active: "#FFA84F"
  },
  colorCategorySocial: {
    normal: "#7288FF",
    hover: "#7D92FF",
    active: "#8396FF"
  },
  colorCategoryShopping: {
    normal: "#F94CA3",
    hover: "#F95AAA",
    active: "#FA61AE"
  },
  colorCategoryRegistrations: {
    normal: "#EEAC2C",
    hover: "#EFB33D",
    active: "#F0B645"
  },
  colorCategoryFinance: {
    normal: "#24C780",
    hover: "#36CB8A",
    active: "#3ECE8F"
  },
  colorCategoryTicket: {
    normal: "#3BBAFE",
    hover: "#4BC0FE",
    active: "#53C2FE"
  },
  colorCategoryTravel: {
    normal: "#C15DF3",
    hover: "#C66AF4",
    active: "#C870F4"
  },
  colorCategoryFees: {
    normal: "#EE3C3C",
    hover: "#EF4C4C",
    active: "#F05353"
  },
  colorTextAccent: {
    normal: "#ffffff"
  },
  colorIconAccent: {
    normal: "#ffffff"
  }
};
exports.default = theme;